import React, { Component } from 'react';
import MiniMapMainMedia from '../MiniMapMainMedia/MiniMapMainMedia';
import ButtonHoverRender from '../../../Buttons/ButtonHover/ButtonHoverRender';
import ButtonHoverPrimary from '../../../Buttons/ButtonHover/ButtonHoverPrimary';
import mapInterface from '../../../../mapboxgl/mapInterface';
import { withTranslation } from 'react-i18next';
import { customGaEvent, PublicGaEvents } from '../../../../utils/ga';
import './MiniMap.scss';

class MiniMap extends Component {
  constructor() {
    super();
    this.state = {
      minimized: window.innerWidth < 1025,
    };
  }

  componentDidMount() {
    const { stops, activeStop } = this.props;
    if (stops[activeStop]) {
      const { lng, lat } = stops[activeStop];
      this.moveToStop({ lng, lat });
      this.setMapZoom();
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const { minimized } = this.state;
    const { activeStop, miniMapView, stops } = this.props;
    if (
      prevProps.activeStop !== activeStop ||
      prevProps.miniMapView !== miniMapView ||
      (prevState.minimized && !minimized)
    ) {
      const { lng, lat } = stops[activeStop];
      this.moveToStop({ lng, lat });
      this.setMapZoom();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setMapZoom = () => {
    const { stops, activeStop, tourData } = this.props;
    const zoom = stops[activeStop].defaultZoom
      ? stops[activeStop].defaultZoom
      : tourData.defaultZoom;
    // defaultZoom for each tour and stop will be null until it's set by the user
    // therefore we need to check that a zoom value exists before calling setZoom();
    if (!this.state.minimized) {
      zoom && mapInterface.getMap().setZoom(zoom);
    }
  };

  moveToStop = ({ lng, lat }) => {
    const mapEl = mapInterface.getMap();
    mapEl && mapInterface.getMap().jumpTo({ center: [lng, lat], zoom: 15 });
  };

  toggleMiniMap = e => {
    const { name } = e.target;
    this.setState(
      prevState => ({ minimized: !prevState.minimized }),
      () => {
        const mapState = this.state.minimized ? 'Close' : 'Open';
        customGaEvent({
          action: PublicGaEvents.MAP_MINIMIZE,
          label: mapState,
        });
      }
    );
    this.handleMapToggleFocus(name);
  };

  handleMapToggleFocus = btnName => {
    setTimeout(() => {
      const focusElName = btnName === 'minimize' ? 'maximize' : 'minimize';
      this[focusElName].focus(); // refs: this.minimize || this.maximize
    }, 250); // timeout allows DOMnode to render otherwise returns undefined/null
  };

  handleSwitchMapView = tourData => {
    const { newMapView, tourId, tourName, aid } = tourData;
    const { switchMapView } = this.props;
    switchMapView({
      miniMapView: newMapView,
      id: tourId,
      name: tourName,
      aid,
    });
  };

  handleResize = () => {
    this.setState({ minimized: window.innerWidth < 1025 });
  }

  render() {
    const { minimized } = this.state;
    const {
      tourData,
      stops,
      panos,
      activeStop,
      miniMapView,
      mainMediaType,
      primaryColor,
      tourId,
      aid,
      tourName,
      tourPublished,
      checkLogoURL,
      closeShareModal,
      changeStop,
      radarPos,
      getPanoRotation,
      path,
      mapToken,
      t,
    } = this.props;

    const newMapView = miniMapView === 'map' ? mainMediaType : 'map';
    const miniIconText = t(`publicTour.miniMap.${miniMapView}`);

    const miniMapIcon =
      miniMapView === 'map' ? (
        <i aria-hidden="true" className="material-icons">
          map
        </i>
      ) : (
        <i aria-hidden="true" className="material-icons">
          panorama_horizontal
        </i>
      );

    const ariaToggleViewLabel =
      miniMapView === 'map'
        ? t(`publicTour.ada.miniMap.toggle.${mainMediaType}.media`)
        : t(`publicTour.ada.miniMap.toggle.${mainMediaType}.map`);

    return (
      <React.Fragment>
        {minimized ? (
          <ButtonHoverRender
            render={({ onEnter, onLeave, hovering }) => (
              <ButtonHoverPrimary
                onEnter={onEnter}
                onLeave={onLeave}
                hovering={hovering}
                color={primaryColor}
                backgroundColor="#fff"
                className="minimap-hide"
                handleClick={this.toggleMiniMap}
                aria-label={t(`publicTour.ada.miniMap.maximize`)}
                name="maximize"
                myRef={btn => (this.maximize = btn)}
                data-cy="minimap-hide"
              >
                <i aria-hidden="true" className="material-icons">
                  map
                </i>
              </ButtonHoverPrimary>
            )}
          />
        ) : (
          <section
            className="minimap-show"
            data-cy="minimap-show"
          >
            <MiniMapMainMedia
              miniMapView={miniMapView}
              stops={stops}
              panos={panos}
              activeStop={activeStop}
              tourPublished={tourPublished}
              tourData={tourData}
              checkLogoURL={checkLogoURL}
              closeShareModal={closeShareModal}
              changeStop={changeStop}
              radarPos={radarPos}
              getPanoRotation={getPanoRotation}
              path={path}
              mapToken={mapToken}
            />
            <ButtonHoverRender
              render={({ onEnter, onLeave, hovering }) => (
                <ButtonHoverPrimary
                  onEnter={onEnter}
                  onLeave={onLeave}
                  hovering={hovering}
                  color={primaryColor}
                  backgroundColor="#fff"
                  className="minimize"
                  handleClick={this.toggleMiniMap}
                  aria-label={t(`publicTour.ada.miniMap.minimize`)}
                  name="minimize"
                  myRef={btn => (this.minimize = btn)}
                  data-cy="minimize-mini-map"
                >
                  <i aria-hidden="true" className="material-icons">
                    open_in_new
                  </i>
                </ButtonHoverPrimary>
              )}
            />
            <span className="minimap-icon" aria-hidden="true">
              {miniMapIcon}
              &nbsp;
              {miniIconText}
            </span>
            <ButtonHoverRender
              render={({ onEnter, onLeave, hovering }) => (
                <ButtonHoverPrimary
                  hovering={hovering}
                  onEnter={onEnter}
                  onLeave={onLeave}
                  color={primaryColor}
                  backgroundColor="#fff"
                  className="switch-view"
                  handleClick={() =>
                    this.handleSwitchMapView({
                      newMapView,
                      tourId,
                      tourName,
                      aid,
                    })
                  }
                  aria-label={ariaToggleViewLabel}
                  aria-live="polite"
                  data-cy="toggle-map-view"
                >
                  <i aria-hidden="true" className="material-icons">
                    swap_horiz
                  </i>
                </ButtonHoverPrimary>
              )}
            />
          </section>
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation()(MiniMap);
